import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import { ROUTES } from '../constants';
import { formatCategoryForUrl } from '../utils';

export default function Home() {
  return (
    <div
      className="relative flex min-h-screen flex-col justify-between bg-gradient-to-br from-[#fafcf8] via-[#f5f9f0] to-[#eef3e7] overflow-x-hidden"
      style={{ fontFamily: '"Plus Jakarta Sans", "Noto Sans", sans-serif' }}
    >
      <div>
        {/* Enhanced Header */}
        <Header />

        {/* Enhanced Hero Section */}
        <div className="relative py-20 px-6">
          <div className="absolute inset-0 bg-gradient-to-br from-[#9be830]/10 to-[#79974e]/10"></div>
          <div
            className="relative max-w-7xl mx-auto"
          >
            <div
              className="flex min-h-[520px] flex-col gap-8 items-center justify-center p-8 bg-cover bg-center bg-no-repeat rounded-3xl shadow-2xl relative overflow-hidden"
              style={{
                backgroundImage:
                  'linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.5)), url("https://lh3.googleusercontent.com/aida-public/AB6AXuA5KS-AlUhhgEY0fyCH-m6ud62k4NA2O3MfrfebFUWfYXtj1VMl1WqE5oZnbogPonb2WURaUGAzJErORz3En3Uy9YTCwakVCY8q9jctagtv5ttIkVjLRVURzpu02k2zwrOudU6GdV8xe1NZ3ViliDExIvZt6v1K3gdqsJxfzWYGyu79nkNv1uA007MjmW_U-v9ltOpYDx7JQIRPW5oS0dPzC-W9ZEb7aAUuVYz3Im8MpslC8bMBg0t7Muh-fhz_Zbf_Hd60E-mb8UA")',
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-[#79974e]/20 to-[#9be830]/20"></div>
              
              <div className="relative flex flex-col gap-6 text-center max-w-4xl">
                <h1 className="text-white text-4xl md:text-6xl font-black leading-tight tracking-tight animate-fadeIn">
                  Sustainable Living 
                  <span className="block bg-gradient-to-r from-[#9be830] to-[#79974e] bg-clip-text text-transparent">
                    Starts Here
                  </span>
                </h1>
                <p className="text-white/90 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed animate-slideInUp">
                  Discover handcrafted bamboo products for a greener lifestyle. Premium quality meets sustainability.
                </p>
              </div>
              
              <div className="relative flex flex-col sm:flex-row gap-4 animate-slideInUp" style={{animationDelay: '0.3s'}}>
                <Link 
                  to="/products"
                  className="group relative px-8 py-4 bg-gradient-to-r from-[#9be830] to-[#8bd020] text-black font-bold text-lg rounded-2xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-3"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256" className="group-hover:rotate-12 transition-transform duration-300">
                    <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM176,88a48,48,0,0,1-96,0,8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0Z"/>
                  </svg>
                  <span>Shop Now</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-[#8bd020] to-[#79974e] opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-2xl -z-10"></div>
                </Link>
                
                <Link 
                  to="/contact"
                  className="group px-8 py-4 bg-white/10 backdrop-blur-sm text-white font-semibold text-lg rounded-2xl border-2 border-white/30 hover:bg-white/20 hover:border-white/50 transform hover:scale-105 transition-all duration-300 flex items-center justify-center gap-3"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 256 256" className="group-hover:scale-110 transition-transform duration-300">
                    <path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"/>
                  </svg>
                  <span>Learn More</span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Enhanced Collections */}
        <div className="py-20 px-6">
          <div className="max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-black text-[#151b0e] mb-4">
                Our <span className="bg-gradient-to-r from-[#9be830] to-[#79974e] bg-clip-text text-transparent">Collections</span>
              </h2>
              <p className="text-[#79974e] text-lg max-w-2xl mx-auto leading-relaxed">
                Discover our premium bamboo products crafted for sustainable living
              </p>
              <div className="w-24 h-1 bg-gradient-to-r from-[#9be830] to-[#79974e] mx-auto mt-6 rounded-full"></div>
            </div>

            <div className="space-y-20">
              {[
                {
                  title: "Kitchenware",
                  desc: "Eco-friendly utensils and cookware made from sustainable bamboo. Perfect for modern kitchens looking to reduce their environmental footprint while maintaining functionality and style.",
                  img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBiWaBvPgMVcbfjHzAapc5P698G0d_EPntW0Qbd5qatNevZCymYDk7LI-6_10d9ExKS33ipAz0JyKvjYdzOk-F9Ff940PQ-Hy_tSYYVFvZIs9aqj01X1OhVbKnO3iLkdtUQQaofskBeT6j5Mfufekdmbm1d3BS8How6YreV8rkrsh-iGv2w0fftc-Xkg172FJKW06WmWeotYGCU5M419jDsbXkAdOPncqbNCfAilttXWVhHaWhcTYNScIuw9SZSRcNCAgrFqYOCV80",
                },
                {
                  title: "Furniture",
                  desc: "Sustainable and stylish bamboo furniture that combines durability with elegant design. Transform your living space with pieces that are both beautiful and environmentally conscious.",
                  img: "https://lh3.googleusercontent.com/aida-public/AB6AXuDIBT1q_BqqIfuyWG8snjBk119_4VkmGvi6eaOtXBIkfZ1M8dqwR7yVKH5c6vv8G119nid0tHTSvcw7nqLDePORQDYYXESfe-kX5myQmztYLR6x8_cPpl5sX-sntykgoKDdM6oh0ibgiVaq6htkaAhn3tDb0SBMOgB7jmgcYNPHF3zo6XejI7JNpvx-i9K0he557bFI8Bv6ln--HBsNic0Z2JYZCniqh8C_nyt6v-1iFmFb1mbnN7i2N6wAkkX6j_pxRMy65U4SHok",
                },
                {
                  title: "Home Decore & Gifts",
                  desc: "Beautiful bamboo home decor items and thoughtful gifts that enhance your living space with natural elegance. Each piece is crafted with attention to detail and environmental sustainability.",
                  img: "https://lh3.googleusercontent.com/aida-public/AB6AXuBgTEg-gSfx2Uk-0sJd4Bgsxhs4Hsf1tDKDC6hdfl8toEw-iD6pIJ-9SvDd6AT5H-LSI4P8PEup08_YSRlT7ci_FtGPvw7v7QoeJsN_ZLEgfgqMs0xheQUVZHN5hW8y62bNblhVDbhUcy9OMOieP6MvCiHPNaZngKXB5gwUajNRrYsxbdubZvNmFbQZgY41IU1gI4gOZR_iPbnpl2g2-AzPsukOPWpYssFbAl4IPbG-xzm53vPlr43Xi11XfQ6M8jTnQpVP1rpczEI",
                },
                {
                  title: "Lamps",
                  desc: "Elegant bamboo lamps that provide beautiful ambient lighting while adding natural elegance to your space. Perfect for creating a warm and inviting atmosphere in any room.",
                  img: "https://lh3.googleusercontent.com/aida-public/AB6AXuDhXDjeXv6smZSREyKJvqB8oPuSP6EN7jCliX2bw3nGDKRXJM2FQ6AQk0ySgAnoq9QI-o8WySo-CJ5nwWnF8hQ7bPUoZAfdwbVAvkXTKM0p4_tnpk_CALFSFNB6VoC9tuxMScYB3H9gMuugsp_ge77YaslGOvHOVVVtGSpBSwFHBNn5TNxqbexPeuxCszcU_Dhp1cSFJdQ8KN_yibX5Hj1PqwbOMZn1pZl7QXjY5aWLmni7a8pSMvBUq7HpfhhjeWEnUp_L6_hXEj4",
                },
              ].map((c, i) => {
                const isEven = i % 2 === 0;
                return (
                  <div key={i} className={`group flex flex-col ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12 py-8`}>
                    {/* Enhanced Image Section */}
                    <div className="w-full lg:w-1/2 relative">
                      <div className="relative overflow-hidden rounded-3xl shadow-2xl">
                        <div
                          className="w-full h-72 lg:h-96 bg-cover bg-center transform transition-transform duration-700 group-hover:scale-110"
                          style={{ backgroundImage: `url(${c.img})` }}
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                        
                        {/* Floating Badge */}
                        <div className="absolute top-6 left-6 bg-gradient-to-r from-[#9be830] to-[#79974e] text-white px-4 py-2 rounded-2xl text-sm font-bold shadow-lg transform -translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                          Premium Quality
                        </div>
                      </div>
                      
                      {/* Decorative Elements */}
                      <div className="absolute -top-4 -right-4 w-24 h-24 bg-gradient-to-r from-[#9be830]/20 to-[#79974e]/20 rounded-full blur-xl"></div>
                      <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-gradient-to-r from-[#79974e]/20 to-[#9be830]/20 rounded-full blur-xl"></div>
                    </div>
                    
                    {/* Enhanced Content Section */}
                    <div className="w-full lg:w-1/2 text-center lg:text-left">
                      <div className="max-w-lg mx-auto lg:mx-0">
                        <h3 className="text-3xl lg:text-4xl font-black text-[#151b0e] mb-6 group-hover:text-[#79974e] transition-colors duration-300">
                          {c.title}
                          <div className="w-16 h-1 bg-gradient-to-r from-[#9be830] to-[#79974e] mt-3 mx-auto lg:mx-0 rounded-full"></div>
                        </h3>
                        <p className="text-[#79974e] text-lg leading-relaxed mb-8 group-hover:text-[#151b0e] transition-colors duration-300">
                          {c.desc}
                        </p>
                        
                        {/* Enhanced Button */}
                        <Link 
                          to={`/products/${formatCategoryForUrl(c.title)}`}
                          className="group/btn relative inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-[#9be830] to-[#79974e] text-white font-bold text-lg rounded-2xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300 overflow-hidden"
                        >
                          <div className="absolute inset-0 bg-gradient-to-r from-[#8bd020] to-[#6d8544] opacity-0 group-hover/btn:opacity-100 transition-opacity duration-300"></div>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256" className="relative z-10 group-hover/btn:rotate-12 transition-transform duration-300">
                            <path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM176,88a48,48,0,0,1-96,0,8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0Z"/>
                          </svg>
                          <span className="relative z-10">Explore {c.title}</span>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 256 256" className="relative z-10 group-hover/btn:translate-x-1 transition-transform duration-300">
                            <path d="m221.66,133.66-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"/>
                          </svg>
                        </Link>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* Enhanced About Section */}
        <div className="relative py-20 px-6 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-[#eef3e7] via-[#f5f9f0] to-[#fafcf8]"></div>
          <div className="absolute top-0 left-0 w-96 h-96 bg-gradient-to-r from-[#9be830]/10 to-[#79974e]/10 rounded-full blur-3xl -translate-x-48 -translate-y-48"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-gradient-to-r from-[#79974e]/10 to-[#9be830]/10 rounded-full blur-3xl translate-x-48 translate-y-48"></div>
          
          <div className="relative max-w-6xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-black text-[#151b0e] mb-6">
                Why Choose <span className="bg-gradient-to-r from-[#9be830] to-[#79974e] bg-clip-text text-transparent">Bamboo?</span>
              </h2>
              <p className="text-[#79974e] text-lg max-w-3xl mx-auto leading-relaxed">
                Bamboo is a rapidly renewable resource, making it an excellent alternative to traditional materials. 
                It's strong, durable, and naturally antibacterial, perfect for a variety of products.
              </p>
              <div className="w-24 h-1 bg-gradient-to-r from-[#9be830] to-[#79974e] mx-auto mt-6 rounded-full"></div>
            </div>

            <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-2xl border border-white/50">
              <p className="text-[#151b0e] text-xl leading-relaxed text-center mb-12 font-medium">
                By choosing bamboo, you're contributing to a more sustainable future 
                while enjoying products that are both beautiful and functional.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                <div className="group text-center p-6 rounded-2xl hover:bg-gradient-to-br hover:from-[#9be830]/10 hover:to-[#79974e]/10 transition-all duration-300">
                  <div className="relative mx-auto mb-6">
                    <div className="w-20 h-20 bg-gradient-to-r from-[#9be830] to-[#79974e] rounded-2xl flex items-center justify-center mx-auto shadow-xl transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                      <span className="text-white text-3xl font-bold">♻️</span>
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-r from-[#9be830] to-[#79974e] rounded-2xl blur-xl opacity-30"></div>
                  </div>
                  <h4 className="text-[#151b0e] font-bold text-xl mb-3 group-hover:text-[#79974e] transition-colors">Eco-Friendly</h4>
                  <p className="text-[#79974e] leading-relaxed">100% renewable and biodegradable materials for a sustainable future</p>
                </div>
                
                <div className="group text-center p-6 rounded-2xl hover:bg-gradient-to-br hover:from-[#9be830]/10 hover:to-[#79974e]/10 transition-all duration-300">
                  <div className="relative mx-auto mb-6">
                    <div className="w-20 h-20 bg-gradient-to-r from-[#79974e] to-[#9be830] rounded-2xl flex items-center justify-center mx-auto shadow-xl transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                      <span className="text-white text-3xl font-bold">💪</span>
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-r from-[#79974e] to-[#9be830] rounded-2xl blur-xl opacity-30"></div>
                  </div>
                  <h4 className="text-[#151b0e] font-bold text-xl mb-3 group-hover:text-[#79974e] transition-colors">Durable</h4>
                  <p className="text-[#79974e] leading-relaxed">Stronger than steel, built to last for generations of use</p>
                </div>
                
                <div className="group text-center p-6 rounded-2xl hover:bg-gradient-to-br hover:from-[#9be830]/10 hover:to-[#79974e]/10 transition-all duration-300">
                  <div className="relative mx-auto mb-6">
                    <div className="w-20 h-20 bg-gradient-to-r from-[#9be830] to-[#79974e] rounded-2xl flex items-center justify-center mx-auto shadow-xl transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                      <span className="text-white text-3xl font-bold">🌿</span>
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-r from-[#9be830] to-[#79974e] rounded-2xl blur-xl opacity-30"></div>
                  </div>
                  <h4 className="text-[#151b0e] font-bold text-xl mb-3 group-hover:text-[#79974e] transition-colors">Natural</h4>
                  <p className="text-[#79974e] leading-relaxed">Antibacterial and antimicrobial properties for healthy living</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />

    </div>
  );
}
